module.exports = __webpack_public_path__ + "static/media/logo-greenbook.cbb6330b.png";